module.exports = __webpack_public_path__ + "img/rich_editor.ccfc5501.svg";